import { render } from "./TestimonialsSection.vue?vue&type=template&id=06ee59ac&scoped=true"
import script from "./TestimonialsSection.vue?vue&type=script&lang=js"
export * from "./TestimonialsSection.vue?vue&type=script&lang=js"

import "./TestimonialsSection.vue?vue&type=style&index=0&id=06ee59ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ee59ac"]])

export default __exports__